// export const appConfig = {
//   appName: "Our Memories",
//   domain: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
//   /** Primary CTA — always open the login page (not /memories). */
//   mainAppUrl: "/login",
//   playStoreUrl: "https://play.google.com/store/apps/details?id=com.sns.om&pcampaignid=web_share",
//   appStoreUrl: "https://apps.apple.com/us/app/om-our-memories/id6760222023",
//   supportEmail: "ourmemories@snssystem.us",
//   tagline: "Digital Album • Flipbook • Guest Book",
//   ctaLabel: "Open Our Memories",
//   ctaLabelShort: "Open Our Memories",
//   ctaLabelHint: "Web app · Free to start",
//   ctaLabelHero: "Get started free",
// };

export const appConfig = {
  appName: "Our Memories",
  domain: typeof window !== "undefined" ? window.location.origin : "https://photostudio.mytiny.us",
  mainAppUrl: "/login",
  playStoreUrl: "https://play.google.com/store/apps/details?id=com.sns.om&pcampaignid=web_share",
  appStoreUrl: "https://apps.apple.com/us/app/om-our-memories/id6760222023",
  supportEmail: "ourmemories@snssystem.us",
  tagline: "Digital Album • Flipbook • Guest Book",
  ctaLabel: "Open Our Memories",
  ctaLabelShort: "Open Our Memories",
  ctaLabelHint: "Web app · Free to start",
  ctaLabelHero: "Get started free",
};

